/**
 * KWC online payment button.
 *
 * NOTHING HERE RUNS ON THE CLICK PATH. The button is an <a href> pointing at a
 * Shopify cart permalink, so the click is a plain browser navigation.
 *
 * This file only:
 *   1. keeps the href's variant id and quantity in step with the page
 *   2. renders the savings preview text
 *   3. refreshes the cart portion of the href AFTER the cart changes
 *
 * Step 3 is the only request this file ever makes, it happens in idle time
 * long before any click, and if it fails the href simply keeps the cart it was
 * rendered with. If this script does not load at all the button still works.
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var key = match ? match[1] : 'amount';

    function withCommas(value, decimals) {
      var parts = (value / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      return parts.join('.');
    }

    var out =
      key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator'
        ? withCommas(cents, 0)
        : withCommas(cents, 2);

    if (key === 'amount_with_comma_separator' || key === 'amount_no_decimals_with_comma_separator') {
      out = out.replace(/,/g, ' ').replace(/\./g, ',').replace(/ /g, '.');
    }

    return format.replace(placeholder, out);
  }

  function initPay(root) {
    var link = root.querySelector('[data-kwc-pay-link]');
    if (!link) return;

    var sourceForm = document.getElementById(root.getAttribute('data-source-form'));
    var savingsEl = root.querySelector('[data-kwc-pay-savings]');
    var percent = parseFloat(root.getAttribute('data-percent')) || 5;
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var suffix = root.getAttribute('data-pay-suffix') || '';

    // Everything before the current variant: "/cart/" plus any other cart line.
    var prefix = root.getAttribute('data-pay-prefix') || cartUrl + '/';

    var variants = [];
    var dataEl = root.querySelector('[data-kwc-pay-variants]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    function currentId() {
      if (sourceForm) {
        var sourceId = sourceForm.querySelector('input[name="id"]');
        if (sourceId && sourceId.value) return parseInt(sourceId.value, 10);
      }
      return parseInt(link.getAttribute('data-variant-id'), 10);
    }

    function currentQty() {
      if (sourceForm) {
        var sourceQty = sourceForm.querySelector('input[name="quantity"]');
        if (sourceQty) {
          var q = parseInt(sourceQty.value, 10);
          if (q > 0) return q;
        }
      }
      return 1;
    }

    function sync() {
      var id = currentId();
      var qty = currentQty();
      if (!id) return;

      link.setAttribute('data-variant-id', String(id));
      link.href = prefix + id + ':' + qty + suffix;

      if (!savingsEl) return;

      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) { variant = variants[i]; break; }
      }
      if (!variant) { savingsEl.textContent = ''; return; }

      var full = variant.price * qty;
      var discounted = Math.round(full * (1 - percent / 100));
      var saved = full - discounted;
      if (saved <= 0) { savingsEl.textContent = ''; return; }

      savingsEl.textContent =
        'Pay ' + formatMoney(discounted, moneyFormat) +
        ' instead of ' + formatMoney(full, moneyFormat) +
        ' · You save ' + formatMoney(saved, moneyFormat);
    }

    /**
     * A cart permalink SETS the cart rather than adding to it, so every other
     * line has to travel in the URL or it would be dropped at checkout. Liquid
     * seeds those lines at render; this re-reads them after the cart changes,
     * which is the only way the page can learn about a drawer add.
     */
    function refreshCartLines() {
      if (typeof fetch !== 'function') return;
      fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var id = currentId();
          var lines = '';
          cart.items.forEach(function (item) {
            if (item.variant_id !== id) lines += item.variant_id + ':' + item.quantity + ',';
          });
          prefix = cartUrl + '/' + lines;
          sync();
        })
        .catch(function () { /* keep the server-rendered cart lines */ });
    }

    if (sourceForm) {
      sourceForm.addEventListener('change', sync);
      sourceForm.addEventListener('input', sync);
    }
    document.addEventListener('variant:update', sync);

    ['cart:update', 'cart:change', 'cart:refresh'].forEach(function (name) {
      document.addEventListener(name, refreshCartLines);
    });

    // Coming back via the back button can restore a stale page with a changed cart.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshCartLines();
    });

    sync();
  }

  function init() {
    document.querySelectorAll('[data-kwc-pay]').forEach(initPay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-kwc-pay]');
    if (root) initPay(root);
  });
})();
